<template>
  <div  v-if="oneselfTracq">
    <div class="roleDialogs u-flex-y u-flex-between">
      <div class="userHeader paddingLR u-flex u-flex-items-center" v-if="CurUser.userInfo">
          <div class="headerImg">
            <img src="/static/room/liwu.png" alt="">
          </div>
          <div class="headerTitle u-flex-y">
            <div class="curNames u-flex u-flex-items-center">
                <span>{{CurUser.userInfo.nickname}}</span>
                <img style="margin-left: 4px;" :src="'/static/newhome/l'+  fifGreed(CurUser.userInfo.level)  + '.webp'" alt="">
            </div>
            <div class="curID">
              <span>龙珠号：</span>
              <span>{{CurUser.userInfo.account}}</span>
            </div>
          </div>
          <div class="closeAlls elementHove" @click="closeAll">
            <img class="newel" src="/static/newroom/closeAlls.png" alt="" srcset="">
            <img class="oldel" src="/static/newroom/closeAll.png" alt="" srcset="">
          </div>
      </div>
      <div class="lines"></div>
      <div class="roleDialogsCnt paddingLR u-flex-y" v-if="showDialogType < 4 && CurUser.userInfo" >
        <div class="u-flex">
          <span>{{CurUser.userInfo.relation.follows}}关注 </span>&nbsp;&nbsp;
          <span> {{CurUser.userInfo.relation.fans}}粉丝</span>
        </div>
        <div class="intro">
          个人简介：<span>有点懒什么都没有留下</span>
        </div>
      </div>
      <div class="roleDialogsCnt paddingLR u-flex-y " v-if="showDialogType ==5">
        <div class="roleDialogswarp">
          <div class="selectBox u-flex u-flex-items-center"  @click="changeState(item,1)" v-for="(item,index) in  userRoleList" :key="index">
            <span class="corl">
              <img v-if="item.state" src="/static/newroom/radios.png" alt="" srcset="">
              <img v-else src="/static/newroom/radio.png" alt="" srcset="">
            </span>
            <span>{{item.name}}</span>
          </div>
        </div>
        <div class="roleDialogswarp" style="margin-top: 9px;">
          <div class="selectBox u-flex u-flex-items-center" @click="changeState(item,2)" v-for="(item,index) in  userRolemethodList" :key="index">
            <span class="corl">
              <img v-if="item.state"  src="/static/newroom/radios.png" alt="" srcset="">
              <img v-else src="/static/newroom/radio.png" alt="" srcset="">
            </span>
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div class="roleDialogsCnt setRoleBox u-flex-y " v-if="showDialogType ==4">
        <div class="roleDialogswarp u-flex ">
          <div class="selectBox u-flex u-flex-items-center"  @click="changeState(item,3)" v-for="(item,index) in  setRoleList" :key="index">
            <span class="corl">
              <img v-if="item.state" src="/static/newroom/radios.png" alt="" srcset="">
              <img v-else src="/static/newroom/radio.png" alt="" srcset="">
            </span>
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div class="nextBtns u-flex u-flex-center u-flex-items-center"  v-if="showDialogType >= 4">
          <div @click="quits" class="nextBtnsItems">取消</div>
          <div v-if="showDialogType ==5" @click="Bntbanned(dialogType)" class="nextBtnsItems" style="margin-left:24px;color: #fff;background-color: #721EDC;">{{dialogType ==1 ?'封禁':'禁言'}}</div>
          <div v-if="showDialogType ==4" @click="setflag" class="nextBtnsItems" style="margin-left:24px;color: #fff;background-color: #721EDC;">设置管理</div>
      </div>
      <div class="btnList paddingLR u-flex u-flex-items-center"  v-if="showDialogType < 4 &&  CurUser.userInfo">
        <span @click="careUser(CurUser.userInfo.relation.folowStatus)">{{
          CurUser.userInfo.relation.folowStatus==0 || CurUser.userInfo.relation.folowStatus==3?'关注':'取关'
        }}</span>
        <span @click="toUserTxt">@TA</span>
        <span @click="ToLiveState(2)" v-if="userRoleStatus.mute !=3">{{userRoleStatus.mute == 1?'禁言':'解禁'}}</span>
        <span @click="ToLiveState(1)" v-if="userRoleStatus.block !=3" >{{userRoleStatus.block ==1?'封禁':''}}</span>
        <span  @click="report" >举报</span>
        <span  @click="setUser(userRoleStatus.manage)" v-if="userRoleStatus.manage !=3" style="min-width: 56px;display: inline-block;">{{userRoleStatus.manage==1?'设为管理':'解除管理'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
import {useroperation,userStartmute,usermute,userunmute,followUser,unfollowUser,profileuser,roomAdd,roomRemove,roomEdit} from '@/api/lz.js'
  export default {
    data() {
      return {
        oneselfTracq: false,
        curUserInfo:{},
        setRoleList:[
          {
            name:'虾兵(正式管理员)',
            state:true,
            id:1,
          },
          {
            name:'蟹将(实习管理员)',
            state:false,
            id:2,
          },
        ],
        userRoleList:[
          {
            name:'1小时',
            state:true,
            id:1,
          },
          {
            name:'3小时',
            state:false,
            id:3,
          },
          {
            name:'24小时',
            state:false,
            id:24,
          },

        ],
        userRolemethodList:[
          {
            name:'色情暴力',
            state:false,
            id:1,
          },
          {
            name:'反动政治',
            state:false,
            id:2,
          },
          {
            name:'侵权',
            state:false,
            id:3,
          },
          {
            name:'广告诈骗',
            state:false,
            id:4,
          },
          {
            name:'其他',
            state:true,
            id:5,
          }
        ],
        reqParams:{
          role:0,             // 当前角色     0没有角色,2为房管,4为实习房管
          roomId:'',
          uid:'',
          muteTimePeriod:1,   // 禁言时间段:1=1小时,3=3小时,24=24小时,-1=永久
          muteReason:5,       // 禁言原因类型:1=色情暴力2=反动政治3=侵权4=广告欺诈5=其他
          typeFlag:1          // 1=房管2=实习房管
        },
        showDialogType:3 , // 弹出 1 普通用户 2.房管 3.群主 4.超管 5.确认弹框
        dialogType:1, // 1、封禁  2、禁言
        userRoleStatus:{
            "block":1,   //封禁 1封禁  3不可执行或不显示
            "mute":1,    //禁言 1禁言  2解禁言  3不可操作或不显示
            "manage":1,  //房管 1设为房管 2解除房管 3不可操作或不显示
        },
        CurUser:{},      // 用户信息
        guanzhuList:[],
        cateStatue:1,

      }
    },
    created() {

    },
    methods:{
      // 用户等级
      fifGreed(v){
        if(v > 60){
          v  = 60
        }
        return v
      },
      // 关注用户
      careUser(type){
        let {uid } = this.reqParams
        console.log('关注用户');
        if(type == 0 || type == 3){
          followUser({
            actionUid:uid
          }).then(res=>{
            if(res.data.code ==  200){
              this.$message.success('关注成功');
              this.CurUser.userInfo.relation.folowStatus = 1
            }else{
              this.$message.success(res.data.message)
            }
          })
        }else{
          unfollowUser({
            actionUid:uid
          }).then(res=>{
            if(res.data.code ==  200){
              this.$message.success('取关成功')
              this.CurUser.userInfo.relation.folowStatus = 0
            }else{
              this.$message.success(res.data.message)
            }
          })
        }
        // 刷新关注列表
        // this.getcareList(uid,2)
        this.close()
      },
      // 获取关注列表
      async getcareList(e, type = 1) {
        this.token = localStorage.getItem("token");
        if (this.token) {
          let list = await this.$store.dispatch('getUserFollowData', type);
          console.log('我的关注列表·', list);
          this.guanzhuList = list;
          this.cateStatue = 1;
          this.guanzhuList.map(item => {
            if (item.uid == e) {
              this.cateStatue = 2;
            }
          })
        }
      },
      // @用户
      toUserTxt(name){
        console.log('@用户');
        this.$emit('changeTxt', this.CurUser.userInfo.nickname);
        this.close()
      },
      // 打开禁言
      ToLiveState(v){

        // let times =  moment('2020-11-16','YYYY-MM-DD').add(120, 'second').format('mm:ss')
        // console.log('时间',times);
        // return
        if(this.userRoleStatus.mute==2 && v == 2){
          this.setUserunmute()
        }else{
          this.dialogType = v;
          this.showDialogType = 5
          console.log('打开禁言',v);
        }
      },
      // 取消
      quits(){
        // 检测用户权限
        this.showDialogType = 1
      },
      // 举报
      report(){
        console.log('举报用户');
        this.$emit('reportUser',this.reqParams.uid)
      },
      // 设置管理
      setUser(vals){
          console.log('设置管理');
          let { roomId,uid } = this.reqParams;
          if(vals == 1){  // 添加房管
           this.showDialogType = 4
          }else{          // 解除房管
            roomRemove({
              roomId:roomId,
              uid:uid,
            }).then(res=>{
              if(res.data.code ==200){
                this.$message.success('已成功移除管理')
                this.quits()
                this.close()
              }else{
                this.$message.error(res.data.message)
              }
            })
          }
      },
      closeAll(){
          // this.showDialogType = 0;
          this.close()
      },
      // 封禁、禁言
      Bntbanned(type){
        console.log(this.reqParams);
        // 封禁
        if(type == 1){
          this.setUserStartmute()
          return
        }
        // 禁言
        if(type == 2){
          this.setUsermute()
          return
        }
      },
      // 设置管理员
      setflag(){
        let { roomId,uid,typeFlag } = this.reqParams;
        roomAdd({
          roomId:roomId,
          uid:uid,
          typeFlag:typeFlag
        }).then(res=>{
          if(res.data.code == 200){
            this.$message.success('设置管理成功')
            this.quits()
            this.close()
          }else{
            this.$message.error(res.data.message)
          }
          console.log('设置管理员');
        })
      },
      changeState(val,type){
        if(type== 1){
          console.log('操作时间',val);
          this.userRoleList.map(item=>{
            if(item.id == val.id){
              item.state = true
            }else{
              item.state = false
            }
          })
          this.reqParams.muteTimePeriod = val.id;
          return
        }
        if(type ==2){
          console.log('操作类型',val);
          this.userRolemethodList.map(item=>{
            if(item.id == val.id){
              item.state = true
            }else{
              item.state = false
            }
          })
          this.reqParams.muteReason = val.id;
          return
        }
        if(type ==3){
          console.log('管理员类型',val);
          this.setRoleList.map(item=>{
            if(item.id == val.id){
              item.state = true
            }else{
              item.state = false
            }
          })
          this.reqParams.typeFlag = val.id;
          return
        }
      },
      // 解禁用户
      setUserunmute(){
        let { roomId,uid,nimFromAccid,nimRoomId } = this.reqParams;
        userunmute({
          roomId,         // 直播间id或主播uid
          uid,            // 要禁言的用户的uid
          nimFromAccid:nimFromAccid,
          nimRoomId:nimRoomId,
        }).then(res=>{
          if(res.data.code == 200){
            this.$message.success('解除禁言成功')
            this.quits()
            this.close()
          }else{
            this.$message.error(res.data.message)
          }
        })
      },
      // 禁用用户发言
      setUsermute(){
        let { roomId,uid,muteTimePeriod,muteReason,nimFromAccid,nimRoomId} = this.reqParams;
        usermute({
          roomId,         // 直播间id或主播uid
          uid,            // 要禁言的用户的uid
          muteTimePeriod:muteTimePeriod, // 禁言时间段:1=1小时,3=3小时,24=24小时,-1=永久
          muteReason:muteReason,     // 禁言原因类型:1=色情暴力2=反动政治3=侵权4=广告欺诈5=其他
          nimFromAccid:nimFromAccid,
          nimRoomId:nimRoomId,
        }).then(res=>{
          if(res.data.code == 200){
            this.$message.success('禁言成功')
            this.quits()
            this.close()
          }else{
            this.$message.error(res.data.message)
          }
        })
      },
      // 超管封禁
      setUserStartmute(){
        let { roomId,uid,muteTimePeriod,muteReason,nimFromAccid,nimRoomId} = this.reqParams;
        userStartmute({
          uid:uid,
          blockTimePeriod:muteTimePeriod,
          blockReason:muteReason,
          nimFromAccid:nimFromAccid,
          nimRoomId:nimRoomId,
        }).then(res=>{
          if(res.data.code == 200){
            this.$message.success('封禁成功');
            this.quits()
            this.close()
          }else{
            this.$message.error(res.data.message)
          }
          // console.log('超管封禁用户',res.data.data);
        })
      },
      initData(){
        let { roomId,uid } = this.reqParams;
        // 当前用户的权限
        useroperation({
          roomId,
          uid
        }).then(res=>{
          if(res.data.code == 200){
            console.log('当前用户的权限',res.data.data);

            /*
                "block":1,   //封禁 1封禁  3不可执行或不显示
                "mute":1,    //禁言 1禁言  2解禁言  3不可操作或不显示
                "manage":1,  //房管 1设为房管 2解除房管 3不可操作或不显示
            */

            this.userRoleStatus = res.data.data;

            // 有封禁
            if(this.userRoleStatus.block ==1){
              this.userRoleList[3] = {
                  name:'永久',
                  state:false,
                  id:-1,
              }
            }



            // showDialogType:3 , // 弹出 1 普通用户 2.房管 3.群主 4.超管 5.确认弹框
            // dialogType:1, // 1、封禁  2、禁言


          }
        })
        // 刷新关注列表
        // this.getcareList(uid,2);
        // 获取当前用户信息
        profileuser({
          uid
        }).then(res=>{
          if(res.data.code == 200){
            console.log('获取用户信息',res.data.data);
            this.CurUser = res.data.data;
          }
        })
      },
      open(data){
        let {roomId,uid ,role,nimFromAccid,nimRoomId} = data
        this.reqParams.roomId = roomId;
        this.reqParams.uid = uid;
        this.reqParams.role = role;
        this.reqParams.nimFromAccid = nimFromAccid;
        this.reqParams.nimRoomId = nimRoomId;
        console.log('操作用户的uid',data);
        this.oneselfTracq = true;
        this.showDialogType = 3
        this.initData()
      },
      close(){
        this.oneselfTracq = false;
        console.log('关闭弹框');
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '@/assets/style/flex.scss';
  .roleDialogs{
   overflow: hidden;
   position: fixed;
   top: 36%;
   right: 2%;
   z-index: 9999;

   // width: 14.2vw;
   width: 280px;


   min-height: 214px;
   background: linear-gradient(180deg, #E5DCFF 0%, #F8F7FA 36%, #F7F8FA 100%);
   border-radius: 4px;
   box-sizing: border-box;
   padding:14px 0 0px;

   .paddingLR{
     padding-left: 12px;
     padding-right: 12px;
   }
   .nextBtns{
     margin-bottom: 12px;
     .nextBtnsItems{
       cursor: pointer;
       width: 86px;
       box-sizing: border-box;
       height: 34px;
       text-align: center;
       background: #EFEFEF;
       border-radius: 17px;
       font-size: 14px;
       font-family: PingFangSC-Regular, PingFang SC;
       font-weight: 400;
       color: #333333;
       line-height: 34px;
     }
   }

   .paddingStatus1{

   }

   .btnList{
     box-sizing: border-box;
      width: 100%;
      height: 40px;
      background: #F0F0F0;
      border-radius: 0px 0px 4px 4px;
      justify-content: flex-start;
      span{
        display: inline-block;
       cursor: pointer;
       padding: 0 4px;
       min-width:40px;
       text-align: center;
       height: 16px;
       font-size: 14px;
       font-family: PingFangSC-Regular, PingFang SC;
       font-weight: 400;
       color: #333333;
       line-height: 16px;
     }
     span:hover{
       color: #721EDC;
     }
   }
   .roleDialogswarp{
     display: flex;
     flex-flow: row wrap;
     align-items: flex-start;
   }
   .setRoleBox{
      padding: 0 4px;
      .corl{
        margin-right: 2px !important;
      }
   }
   .roleDialogsCnt{
     flex: 2;
     font-size: 14px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: #999999;
     line-height: 14px;

     .selectBox:hover{
       cursor: pointer;
       span{
         color: #721EDC;
       }
     }
     .selectBox{
       user-select: none;
       margin-top:6px;
       margin-right:10px;
       span{
         display: inline-block;
         font-size: 14px;
         font-family: PingFangSC-Regular, PingFang SC;
         font-weight: 400;
         color: rgba(0,0,0,0.65);
       }
       .corl{
         margin-right: 2px;
         width: 16px;
         height: 16px;
         img{
           width: 16px;
           height: 16px;
         }
       }
     }
     .selectBox:last-child{
       margin-right:0 !important;
     }
     .intro{
       margin-top: 12px;
     }
   }
   .lines{
     padding-bottom:6px;
     margin: 0 12px;
     box-sizing: border-box;
     margin-bottom: 12px;
     border-bottom: 1px solid #e9e9e9;
   }
   .userHeader{
     position: relative;
     .closeAlls:hover{
       transform: rotate(0deg);
     }
     .closeAlls{
       cursor: pointer;
       position: absolute;
       right: 8px;
       top: -4px;
       padding: 4px;
       img{
         width: 18px;
         height: 18px;
       }
     }
     .headerTitle{
       .curID{
         display: inline-block;
         margin-top: 12px;
         height: 14px;
         font-size: 14px;
         font-family: PingFangSC-Regular, PingFang SC;
         font-weight: 400;
         color: #999999;
         line-height: 14px;
       }
       .curNames{
         img{
           width:40px;
           height: 14px;
           // background: #91C2F2;
           border-radius: 1px;
         }
         span{
           display: inline-block;
           height: 16px;
           font-size: 16px;
           font-family: PingFangSC-Medium, PingFang SC;
           font-weight: 600;
           color: #333333;
           line-height: 16px;
         }
       }
     }
      .headerImg{
        width: 40px;
        height: 40px;
        margin-right: 9px;
        img{
          width: 40px;
          height: 40px;
        }
      }
   }
  }

  .tracqCss:hover {
    transform: rotate(180deg);
    cursor: pointer;
    transition: transform 0.5s ease;
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_roledialog.vue